module.exports = __webpack_public_path__ + "img/disclaimer-zhTc.64cd5a44.png";